import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LCPAdminFeaturesService {

  // Constants that we can change service wide.
  inputMaxLimit : number = 300;                 // mutation capped.

  //
  // For Support Admin this return the selected Organization from the Account Picker.
  //
  selectedTenantIdSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  selectedTenantId$: Observable<string> = this.selectedTenantIdSubject.asObservable();

  selecttenantId(tenantId: string): void {
    this.selectedTenantIdSubject.next(tenantId);
  }
  getSelecttenantId() {
    return this.selectedTenantId$;
  }





}
